import * as React from "react";
import OutlookDialog from "../OutlookDialog"
import { 
    useId,
    Toaster,
    useToastController,
    ToastTitle,
    Toast,
    Button, 
    Spinner,
} from "@fluentui/react-components";
import PropTypes from "prop-types";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
    primaryButton: {
        backgroundColor: "#1a4ed8",
        color: "white",
        fontSize: "18px",
        fontWeight: "400",
        marginBottom: "20px",
        transition: "background-color 0.2s ease",
        '&:hover': {
            backgroundColor: '#1a4ed8',
            color: "white",  
            opacity: "0.7"         
        },
    },
    buttonImg: {
        filter: "brightness(0) invert(1)",
        marginRight: "6px",
        transition: "filter 0.2s ease-in-out"
    }
});


const CandidateParse = ({outlookNotification,outlookAttachments,outlookMessage,outlookAccesToken,setLogout}) => {
    const styles = useStyles();

    const [openDialog1, setOpenDialog1] = React.useState(false);
    const [openDialog2, setOpenDialog2] = React.useState(false);
    const [noAttachDialog, setNoAttachDialog] = React.useState(false);
    const [attachment, setAttachment] = React.useState(null);
    const attachs = outlookAttachments();

    const toasterId = useId("toaster");
    const { dispatchToast, dismissAllToasts } = useToastController(toasterId);
    const [position, setPosition] = React.useState("bottom");

    const notify = (msg,intent) => {
        switch (intent) {
            case "progress" : 
                dispatchToast(
                    <Toast>
                        <ToastTitle media={<Spinner size="tiny" />}>{msg}</ToastTitle>
                    </Toast>,
                    { position, intent: intent, timeout:-1}
                );
                break;
            case "error":
            case "info":
            case "success":
            case "warning":
                dispatchToast(
                    <Toast>
                        <ToastTitle>{msg}</ToastTitle>
                    </Toast>,
                
                { position, intent: intent }
                );
                break;
        }
    }

    React.useEffect(()=>{
            if(attachs.length == 1 ){
                setAttachment(attachs[0].id);
            }
    },[])

    const candidateParse = async (attachment) => {

         var accessToken = await outlookAccesToken();

        var resp = await makeCandidateParseRequest(accessToken.token);

        //***Open the result in Browser tab ****//
        if(resp.hasOwnProperty('data')){
            outlookNotification("Candidate parsed successfully!!");
            notify("Candidate parsed successfully!!",'success');
            // Office.context.ui.displayDialogAsync(resp.data.url, { height: 30, width: 20 });
            if(Office.context.mailbox.diagnostics.hostName == 'OutlookWebApp'){
                window.open(resp.data.url);
            }else{
                Office.context.ui.openBrowserWindow(resp.data.url);
            }
        }

        
    };

    const OutlookAttachments = () => {
    
        return (
            attachs.length > 1 ? attachs.map((attch,idx) => (
                <p key={idx}><label htmlFor={idx}><input id={idx} type="radio" value={attch.id} name="email_attachments" onChange={(e) => handleAttachSelect(e)} checked={attachment==attch.id ? 'checked' : '' }/>&nbsp;{attch.name}</label></p>
            ))
            : <Spinner labelPosition="above" label="Parsing Candidate Profile for candidate parser..." /> 
        )
    }

    const handleAttachSelect = (e) => {
        setAttachment(e.target.value);
    }

    const handleDialogAction = async () => {
        setOpenDialog1(false)
        setOpenDialog2(true)
        
        if(attachment != null){
            await candidateParse(attachment);
        }else{
            outlookNotification("No Attachement Data selected");
            notify("No Attachement selected!",'warning');
            setOpenDialog2(false)
            setOpenDialog1(true)
        }
        
    }

    const handleCandidateparse = async (e) => {

        if(attachs.length == 0){
            setNoAttachDialog(true);
            return false;
        }

        setOpenDialog1(true)
        if(attachs.length >= 1){
           await candidateParse(attachment);
        }
    };

    const makeCandidateParseRequest = async (accessToken) => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("x-auth-token", Office.context.roamingSettings.get("ehAuthToken"));
        
        const requestOptions = {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                "e": Office.context.mailbox.userProfile.emailAddress,
                "mid": Office.context.mailbox.convertToRestId(
                    Office.context.mailbox.item.itemId,
                    Office.MailboxEnums.RestVersion.v2_0
                  ),
                "aid": Office.context.mailbox.convertToRestId(
                    attachment,
                    Office.MailboxEnums.RestVersion.v2_0
                  ),
                "description": await outlookMessage(),
                "parse_type": "candidate_parse",
                "token": accessToken
            }),
            redirect: "follow"
        };

        return new Promise((resolve,reject)=>{
            fetch(`https://ce-api.excelhire.com/outlook/balaji-download-attachment`, requestOptions)
            .then((response) => response.json())
            .then((result) => {

                if(result.hasOwnProperty('error')){
                    notify(result.error,'error');
                    setTimeout(()=>{
                         setLogout(true);
                    },1000)
                }

                setOpenDialog1(false)
                setOpenDialog2(false)

                if(result.response.hasOwnProperty('error')){
                    notify(result.response.error,'error');
                }

                resolve(result.response);
            })
            .catch((error) => {
                setOpenDialog1(false)
                setOpenDialog2(false)
                resolve("Error parsing candidate: " + error.message);
            });
        })
        
    }

    return (
        <>
            <Button className={styles.primaryButton} appearance="secondary" disabled={false} size="large" onClick={(e) => handleCandidateparse()}>
            <span><img className={styles.buttonImg} width="20" src="assets/candidate_parse.png" /></span><span>Candidate Parse</span>
            </Button>
            <OutlookDialog 
                // trigger={}
                title={attachs.length > 1 && "Choose a attachment" }
                content={<OutlookAttachments />}
                open={openDialog1}
                onOpenChange={(event, data)=>{
                    setOpenDialog1(data.open);
                }}
                action={attachs.length > 1 ? true : false}
                actionButton={attachs.length > 1 && <Button onClick={handleDialogAction} appearance="primary">Send</Button>}
            />
            <OutlookDialog 
                content={<Spinner labelPosition="above" label="Parsing Candidate Profile for candidate parser..." />}
                open={openDialog2}
                onOpenChange={(event, data)=>{
                    setOpenDialog2(data.open);
                }}
                action={false}
            />
            <OutlookDialog 
                content="This email has no attachment."
                open={noAttachDialog}
                onOpenChange={(event, data)=>{
                    setNoAttachDialog(data.open);
                }}
                action={true}
            />
            <Toaster inline toasterId={toasterId} />
        </>
    )

}



CandidateParse.propTypes = {
    outlookNotification: PropTypes.func.isRequired,
};

export default CandidateParse;